import applyBlockDepthDelta from './applyBlockDepthDelta';
import { type TFlatBlock } from './blocksToFlatDocument';

export default function applyDepth(flatBlocks: TFlatBlock[], blockId: string, depth: number) {
  const result = flatBlocks.slice();
  let index = flatBlocks.findIndex((b) => b.id === blockId);

  if (index < 0) {
    return result;
  }

  const oldDepth = flatBlocks[index].depth;
  const delta = depth - oldDepth;
  result[index] = applyBlockDepthDelta(flatBlocks[index], delta);
  index++;
  while (index < flatBlocks.length && flatBlocks[index].depth > oldDepth) {
    result[index] = applyBlockDepthDelta(flatBlocks[index], delta);
    index++;
  }
  return result;
}
